import React, { useState } from 'react'
import { Popover, PopoverBody, PopoverHeader, Button } from "reactstrap"
import leftJoinImage from '../../../assets/images/inner_join_left.png'
import rightJoinImage from '../../../assets/images/inner_join_right.png'
import InnerJoinImage from '../../../assets/images/inner_join.png'

export default function Heading({ isCollapseOpen, setIsCollapseOpen }) {
    const [popoverOpen, setPopoverOpen] = useState(false);

    const toggle = () => setPopoverOpen(!popoverOpen);
    const hidePopover = () => setPopoverOpen(false)
    const toggleCollapse = () => setIsCollapseOpen(!isCollapseOpen)

    return (
        <>
            <Popover placement="right-start" isOpen={popoverOpen} target="Popover1" toggle={toggle}>
                <PopoverHeader>Types de jointure</PopoverHeader>
                <PopoverBody>
                    <JoinFormsTooltip />
                </PopoverBody>
            </Popover>
            <div className="flex justify-between">
                <div>
                    <h4 className="mb-0 position-relative d-inline-block">
                        Joindre formulaires{" "}
                        <i id="Popover1" onMouseOver={toggle} onMouseOut={hidePopover} className="ti-help-alt help-icon"></i>
                    </h4>
                </div>
                <Button color="light" onClick={toggleCollapse}>
                    <i
                        className={`font-bold text-lg ${!isCollapseOpen ? "ti-plus" : "ti-minus"}`}
                    />
                </Button>
            </div>
        </>
    )
}

function JoinFormsTooltip() {
    return <div>
        <div className="flex items-center justify-center">
            <img src={leftJoinImage} style={{ width: "64px", marginRight: 10 }} />
            <p className="font-bold text-md">LEFT JOIN</p>
        </div>
        Keep all rows of the left dataset and add information from the right dataset <br />
        <div className="flex items-center justify-center">
            <img src={rightJoinImage} style={{ width: "64px", marginRight: 10 }} />
            <p className="font-bold text-md">RIGHT JOIN</p>
        </div>
        Keep all matches and keep rows without match from the right dataset<br />
        <div className="flex items-center justify-center">
            <img src={InnerJoinImage} style={{ width: "64px", marginRight: 10 }} />
            <p className="font-bold text-md">INNER JOIN</p>
        </div>
        Keep matches and drop rows without match from both datasets
    </div>
}